/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { PriceFormatComponent, PriceFormatKeyEventChecker, PriceFormatOptions, PriceFormatTransformer, PriceFormatValidator, PriceFormatModule, MatPriceFormatModule } from './public_api';
export { BasePriceFormatComponent as ɵa } from './src/component/base-price-format.component';
export { MatPriceFormatComponent as ɵb } from './src/component/mat/mat-price-format.component';
